import React from 'react';
import { sendEvent } from '@JohnLewisPartnership/experiments-utils';
import styles from './StoreFinderButton.scss';

export const StoreFinderButton = () => {
  const clickHandler = () => {
    sendEvent('mobile-menu-click.store-finder-button');
  };

  return (
    <div className={styles.storeFinder}>
      <a
        className={styles.storeFinder__button}
        data-testid="nav-store-finder"
        href="/our-shops"
        onClick={clickHandler}
      >
        Find a store
      </a>
    </div>
  );
};
